//---------------------------------------------

//  --  全ページ共通で利用するもの

//---------------------------------------------
export default class networkSlide {
    constructor(effect) {


        this.$container;
        this.$target;
        this.$page = {
            container:"",
            current : ""
        };

        this.ctrl = {
            $prev : "",
            $next : ""
        };
        this.status = {
            current : 0,
            prevCurrent:0,
            time : 0,
        };

        this.conf = {
            NUM   : 0,
            PAUSE : 240,
        };

    }
    init(){
        this.$container = document.getElementById("l-networks-corp-slide");
        this.ctrl.$prev = this.$container.getElementsByClassName("prev");
        this.ctrl.$next = this.$container.getElementsByClassName("next");

        this.$target = this.$container.getElementsByClassName("l-screen-list");
        this.conf.NUM = this.$target.length;

        this.$page.container = this.$container.getElementsByClassName("l-ctrl-page");
        this.$page.current = this.$page.container[0].getElementsByClassName("current");

        for(let i=0; i<this.conf.NUM; i++){
            if(i!=this.status.current) TweenMax.set(this.$target[i],{x:-200,opacity:0});
        }


        this.ctrl.$prev[0].addEventListener("click",(e)=>{
            e.stopPropagation();
            this.update("prev");
        });
        this.ctrl.$next[0].addEventListener("click",(e)=>{
            e.stopPropagation();
            this.update("next");
        });


    }
    update(dir){


        this.status.prevCurrent = this.status.current;
        this.status.time = 0;

        if(dir === "next"){
            if(this.ctrl.$prev[0].classList.contains("is-disable")) this.ctrl.$prev[0].classList.remove("is-disable")
            if(this.conf.NUM-2>this.status.current){
                this.status.current = this.status.current+1;
                this.ctrl.$next[0].classList.remove("is-disable")
            }else{
                this.status.current = this.conf.NUM-1;
                this.ctrl.$next[0].classList.add("is-disable")
            }

        }else{
            if(this.ctrl.$next[0].classList.contains("is-disable")) this.ctrl.$next[0].classList.remove("is-disable")
            if(1<this.status.current){
                this.status.current = this.status.current-1;
                this.ctrl.$prev[0].classList.remove("is-disable")
            }else{
                this.status.current = 0;
                this.ctrl.$prev[0].classList.add("is-disable")
            }
        }


        this.$page.current[0].textContent = this.status.current+1;

        for(let i=0; i<this.conf.NUM; i++){
            this.$target[i].classList.remove("is-current");
        }
        this.$target[this.status.current].classList.add("is-current");

        // TweenMax.staggerTo(this.$target,0.6,{
        //     x:-100,
        //     opacity:0,
        //     ease:Power2.easeOut
        // },0.05);
        //
        TweenMax.to(this.$target[this.status.prevCurrent],0.4,{
            x:-150,
            opacity:0,
            display:'none',
            ease:Power2.easeOut
        });
        TweenMax.to(this.$target[this.status.current],0.4,{
            x:0,
            opacity:1,
            display:'flex',
            ease:Power2.easeOut
        });

    }
}